import { LogoPropsType } from './logoTypes';

export default function ScalaLogo({ className }: LogoPropsType) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M7 12.3077C7 12.3077 25.4615 14.1539 25.4615 17.2308V9.84617C25.4615 9.84617 25.4615 6.76925 7 4.92309V12.3077Z"
        fill="url(#paint0_linear_7846_10641)"
      />
      <path
        d="M7 22.1538C7 22.1538 25.4615 24 25.4615 27.0769V19.6923C25.4615 19.6923 25.4615 16.6154 7 14.7692V22.1538Z"
        fill="url(#paint1_linear_7846_10641)"
      />
      <path
        d="M25.4615 0V7.38461C25.4615 7.38461 25.4615 10.4616 7 12.3077V4.92309C7 4.92309 25.4615 3.07692 25.4615 0Z"
        fill="url(#paint2_linear_7846_10641)"
      />
      <path
        d="M7 14.7692C7 14.7692 25.4615 12.9231 25.4615 9.84617V17.2308C25.4615 17.2308 25.4615 20.3077 7 22.1538V14.7692Z"
        fill="url(#paint3_linear_7846_10641)"
      />
      <path
        d="M7 32V24.6154C7 24.6154 25.4615 22.7692 25.4615 19.6923V27.0769C25.4615 27.0769 25.4615 30.1538 7 32Z"
        fill="url(#paint4_linear_7846_10641)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7846_10641"
          x1="7.03151"
          y1="15.8874"
          x2="25.4281"
          y2="15.8874"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#656565" />
          <stop offset="1" stopColor="#010101" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7846_10641"
          x1="7.03151"
          y1="15.9424"
          x2="25.4281"
          y2="15.9424"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#656565" />
          <stop offset="1" stopColor="#010101" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7846_10641"
          x1="7.03151"
          y1="16.0166"
          x2="25.4281"
          y2="16.0166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9F1C20" />
          <stop offset="1" stopColor="#ED2224" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7846_10641"
          x1="7.03151"
          y1="16.0832"
          x2="25.4281"
          y2="16.0832"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9F1C20" />
          <stop offset="1" stopColor="#ED2224" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_7846_10641"
          x1="7.03151"
          y1="25.9003"
          x2="25.4281"
          y2="25.9003"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9F1C20" />
          <stop offset="1" stopColor="#ED2224" />
        </linearGradient>
      </defs>
    </svg>
  );
}
